import React from "react"
import { PiShareFatLight } from "react-icons/pi"

import Button from "@fuse/sharedComponents/buttons/SolidBtn"

import NoData from "@fuse/assets/icons/no_data.svg"

import { useEvents } from "../eventPage/controller"

const EmptyGuestList = ({
  isSearching,
  eventId,
  tab,
}: {
  isSearching?: boolean
  eventId?: string
  tab: "going" | "invited" | "awaiting" | "not_going"
}) => {
  const { handleShare } = useEvents(eventId)

  const getSubTitle = () => {
    switch (tab) {
      case "awaiting":
        return "If your event requires your approval, pending guests will show up in this list.\nShare your event link to start filling your guest list."
      case "going":
        return "As soon as a guest joins, you’ll see them here.\nShare this event and fill up your guest list!"
      case "not_going":
        return "Anyone who opts out or you decline will be listed here. So far, no one has bowed out."
      default:
        return "Share this event and fill up your guest list!"
    }
  }

  return (
    <div className="w-full flex flex-col items-center justify-center gap-6">
      <div className="bg-white/10 rounded-2xl p-6">
        <img src={NoData} />
      </div>
      <div className="flex flex-col gap-3">
        <div className="text-white">
          {isSearching
            ? "No results found"
            : tab === "awaiting"
              ? "No awaiting guests yet"
              : "No guests in this category"}
        </div>
        <div className="text-white/50 whitespace-pre-line">
          {isSearching
            ? "We couldn't find any guests matching your search"
            : getSubTitle()}
        </div>
      </div>
      {!isSearching && (
        <Button
          icon={<PiShareFatLight />}
          className="w-5/12 lg:w-3/12"
          onClick={handleShare}
        >
          Share
        </Button>
      )}
    </div>
  )
}

export default EmptyGuestList
